import React from 'react';

const TONES = {
  steel: 'bg-komal-blue',
  go: 'bg-green-600',
  warn: 'bg-amber-500',
};

const WeightGauge = ({ value, tone }) => {
  const pct = Math.max(0, Math.min(100, value || 0));
  const resolvedTone = tone || (pct >= 90 ? 'go' : 'steel');

  return (
    <div className="relative h-3.5 bg-gray-200 rounded-sm overflow-hidden border border-gray-300">
      <div
        className={`absolute inset-y-0 left-0 transition-all ${TONES[resolvedTone]}`}
        style={{ width: `${pct}%` }}
      />
      <div className="absolute inset-0 flex">
        {[10, 20, 30, 40, 50, 60, 70, 80, 90].map((t) => (
          <div key={t} className="absolute top-0 bottom-0 w-px bg-black/10" style={{ left: `${t}%` }} />
        ))}
      </div>
    </div>
  );
};

export default WeightGauge;
